import axios from 'axios'
import store from 'store'
import { history } from '../../index'

export const apiClient = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  timeout: 10000,
  // headers: { 'X-Custom-Header': 'foobar' }
})

apiClient.interceptors.request.use(request => {
  const authToken = store.get('authToken')
  if (authToken) {
    request.headers.Authorization = `Bearer ${authToken}`
    request.headers.AuthToken = authToken
  }
  return request
})

// Avoid error interceptor or deal with all the possible error here
apiClient.interceptors.response.use(
  response => response,
  error => {
    let returnedError = 'Internal Error'
    const hasResponse = Object.prototype.hasOwnProperty.call(JSON.stringify(error), 'response')
    /* eslint-no-prototype-builtins */
    if (hasResponse) {
      console.log('yes, interceptor has a response')
      if (error.response.status === 401) {
        console.log('Redirection needed !')
        localStorage.clear()
        returnedError = error.response
        history.push('/auth/login')
      }
    } else {
      console.log('interceptor error', error.message)
      console.log('Something when wrong', JSON.stringify(error))
      returnedError = error.message
    }
    return returnedError
    // return Promise.reject(error)
  },
)

export default apiClient
